const reducer = (state, action) => {
    switch (action.type) {
        case "SET_SESSION": {
            return { ...action.payload };
        }

        case "CLEAR_SESSION": {
            return {};
        }

        default: {
            return state;
        }
    }
};

export default reducer;
